<template>
	<div id="app">
		<Header/>
		<Headline/>
		<Menu/>
		<Footer/>
	</div>
</template>

<script>
	import Header from './components/Header.vue'
	import Headline from './components/Headline.vue'
	import Menu from './components/Menu.vue'
	import Footer from './components/Footer.vue'
	
	export default {
		name: 'app',
		metaInfo: {
			title: 'Quoc Huong Banh Mi Fast Food',
			titleTemplate: '%s',
			htmlAttrs: {
				lang: 'en-US'
			},
			meta: [
				{ charset: 'utf-8' },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ name: 'description', content: 'Quoc Huong Banh Mi Fast Food Vietnamese Restaurant' },
				{ name: 'canonical', content: 'https://banhmiquochuong.com/' },
				// Facebook OpenGraph tags
				{ name: 'og:title', content: 'Quoc Huong Banh Mi Fast Food Vietnamese Restaurant' },
				{ name: 'og:description', content: 'Quoc Huong Banh Mi Fast Food Vietnamese Restaurant' },
				{ name: 'og:type', content: 'website' },
				{ name: 'og:url', content: 'https://banhmiquochuong.com/' },
				{ name: 'og:image', content: 'https://banhmiquochuong.com/img/logo.3274bb45.png' },
				// Twitter summary cards
				{ name: 'twitter:card', content: 'summary' },
				{ name: 'twitter:site', content: 'https://banhmiquochuong.com/' },
				{ name: 'twitter:creator', content: '@' },
				{ name: 'twitter:title', content: 'https://banhmiquochuong.com/' },
				{ name: 'twitter:site', content: 'Quoc Huong Banh Mi Fast Food Vietnamese Restaurant' },
				{ name: 'twitter:image', content: 'https://banhmiquochuong.com/img/logo.3274bb45.png' },
			],
			link: [
				{ rel: 'favicon', href: '/assets/images/favicons/favicon.ico' },
			],
			noscript: [
				{ innerHTML: 'This website requires JavaScript.' }
			]
		},
		components: { Header, Headline, Menu, Footer }
	}
</script>

<style>
	@import url('https://fonts.googleapis.com/css?family=Raleway');
	* {
		margin: 0;
		font-family: 'Raleway', sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}
	.section-title {
		color: #da251dff;
		margin: auto;
	}
	.default-color {
		color: #000;
	}
	.primary-color {
		color: #da251dff;
	}
	.secondary-color {
		color: #ffff00ff;
	}
	.line-through {
		display: table;
		white-space: nowrap;
	}
	.line-through:before,
	.line-through:after {
		border-top: 3px solid rgba(218, 37, 29, 0.75);
		content: '';
		display: table-cell;
		position: relative;
		top: 0.6em;
		width: 40%;
	}
	.line-through:before {
		right: 1.5%;
	}
	.line-through:after {
		left: 1.5%;
	}
</style>